/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-12-23 10:17:36
 * @FilePath: \mrc-base-frontend\src\service\api\app_version.js
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-23 13:13:29
 */
//  app版本控制
import http from "../httpConfig";

const table = "mrbase_sys_app_version_upgrade";
// 获取列表
export const get_list = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/app-version-upgrade/get-list/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 根据uuid获取详情
export const get_version_detail = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/app-version-upgrade/get-details/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 根据uuid修改
export const getChange = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/app-version-upgrade/update/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
//新增
export const getAdd = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/app-version-upgrade/add/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 根据uuid删除
export const getDelete = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/app-version-upgrade/delete/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
